var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.357 5.432c.355 0 .643-.242.643-.54V3.54c0-.299-.288-.541-.643-.541H3.643C3.288 3 3 3.242 3 3.54v1.352c0 .298.288.54.643.54h16.714zm0 7.784c.355 0 .643-.242.643-.54v-1.352c0-.298-.288-.54-.643-.54H3.643c-.355 0-.643.242-.643.54v1.352c0 .298.288.54.643.54h16.714zm0 7.784c.355 0 .643-.242.643-.54v-1.352c0-.298-.288-.54-.643-.54H3.643c-.355 0-.643.242-.643.54v1.351c0 .299.288.541.643.541h16.714z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/a3548c3390f4ec8e3d4ffc9ff8d83576-Hamburger.svg";
export { SvgHamburger as ReactComponent };